import { Injectable, OnInit } from '@angular/core';
import { AuthQuery } from '@ascschool/core/auth';
import { AuthService } from '@ascschool/core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SizePageService implements OnInit {
  
  constructor(private _auth: AuthQuery) {
    
  }
  ngOnInit(){
   
  }
  caculateHeight(...element) {
    let numChange;  
    let positionMenu = JSON.parse(localStorage.getItem('userSetting')).settings.positionMenuNav; 
    
    if(positionMenu === 'top'){
      numChange = 175;
    }else if(positionMenu === 'left'){
      numChange = 135;
    }
    const maxHeight: number = window.outerHeight;
    let sum = 0;
    for (const elementHeight of element) {  
      
      if (typeof elementHeight === 'object' && elementHeight !== null) {
        sum += elementHeight.nativeElement.offsetHeight;
      } else if (typeof elementHeight === 'number' && elementHeight !== null) {
        sum += elementHeight;
      } 
    }
    return maxHeight - sum - numChange;
  }
  caculateWidth(element) {
    const widthPage: number = element.nativeElement.offsetWidth;
    if (widthPage < 1200){
      return 1150;
    }else if (widthPage < 1500){
      return  1500;
    }else if (widthPage < 1800){
      return  1500;
    }
    return widthPage;
  }
}
